import { createStore } from 'zustand/vanilla';
import { type IConfig } from '@/common/utils/domain-config-manager';

export interface DomainState {
  config: IConfig | null;
  isTenant: boolean;
}

interface DomainActions {
  setDomainConfig: (config: IConfig) => void;
  setIsTenant: (isTenant: boolean) => void;
  clear: () => void;
}

export type DomainStore = DomainState & DomainActions;

export const initDomainStore = (
  config: IConfig | null = null,
  isTenant: boolean = false
): DomainState => {
  return {
    config,
    isTenant,
  };
};

const defaultInitState: DomainState = {
  config: null,
  isTenant: false,
};

export const createDomainStore = (
  initState: DomainState = defaultInitState
) => {
  return createStore<DomainStore>()((set) => ({
    ...initState,
    setDomainConfig: (config) => {
      set({ config });
    },
    setIsTenant: (isTenant) => {
      set({ isTenant });
    },
    clear: () => {
      set({ config: null, isTenant: false });
    },
  }));
};

// Re-export the new domain store implementation
// The old persistent store has been replaced with a per-request context-based store

export {
  useDomainStore,
  selectDomain,
  selectIsTenant,
} from '@/providers/domain-store-provider';
